export default {
  required: 'The {{field}} field is required.',
  passwordConfirmation: 'Your new password and confirmation password do not match. ',
  dateEndBeforeDateStart: "End date can't be before start date",
};
